import { EErrorType } from '../types/enums';

export const API_ERROR_CODES: Record<string, string> = {
  [EErrorType.INVALID_CODE]: 'Invalid code',
};
